import { render, staticRenderFns } from "./VConversationContainer.vue?vue&type=template&id=0a6fbcf4&scoped=true&"
import script from "./VConversationContainer.vue?vue&type=script&lang=js&"
export * from "./VConversationContainer.vue?vue&type=script&lang=js&"
import style0 from "./VConversationContainer.vue?vue&type=style&index=0&id=0a6fbcf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6fbcf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VBtn,VIcon,VTextField,VToolbar,VToolbarTitle})
